import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center bg-navy overflow-hidden pt-20 md:pt-0" data-id="element-145">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-146">
        <img src="https://cdn.magicpatterns.com/uploads/253mjiKPHQHTDz6KodoTku/ChatGPT_Image_26_may_2026,_17_05_57.png" alt="RenuevaTE_90 Background" className="w-full h-full object-cover opacity-30" data-id="element-147" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/80 via-navy/90 to-navy bg-[#0D1B3E]" data-id="element-148"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-16 md:py-24 text-center flex flex-col items-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} data-id="element-150">
          <img src="https://cdn.magicpatterns.com/uploads/81dbfNW6C6WxGsU82gWpWz/ChatGPT_Image_26_may_2026,_17_06_14.png" alt="Logo" className="h-24 md:h-32 mx-auto mb-8 drop-shadow-2xl" data-id="element-151" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="font-serif text-4xl md:text-6xl lg:text-7xl text-cream leading-tight mb-6 max-w-4xl" data-id="element-152">
          90 días para <span className="text-gold italic" data-id="element-153">RENOVARTE</span> de
          adentro hacia afuera
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.4
      }} className="text-xl md:text-2xl text-cream/90 font-light mb-10 max-w-2xl" data-id="element-154">
          sin dietas extremas, sin perderte la vida.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="flex flex-wrap justify-center gap-3 md:gap-6 mb-12" data-id="element-155">
          {['DESPERTAR DEL CUERPO', 'NUTRICIÓN', 'BIENESTAR', 'MENTE', 'ESPÍRITU'].map((pillar, idx) => <span key={idx} className="text-gold text-xs md:text-sm font-semibold tracking-widest border border-gold/30 px-4 py-1.5 rounded-full bg-navy/50 backdrop-blur-sm" data-id="element-156">
              {pillar}
            </span>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.8
      }} className="flex flex-col items-center w-full max-w-md" data-id="element-157">
          <a href="#diagnostico" className="w-full bg-gold hover:bg-gold/90 font-bold text-lg md:text-xl py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] transform hover:-translate-y-1 flex items-center justify-center gap-2 text-[#0D1B3E]" data-id="element-158">
            QUIERO COMENZAR MI TRANSFORMACIÓN{' '}
            <span className="text-2xl leading-none" data-id="element-159">→</span>
          </a>

          <div className="w-full mt-6" data-id="element-160">
            <div className="flex justify-between text-cream/80 text-sm mb-2 font-medium" data-id="element-161">
              <span data-id="element-162">Cohorte de junio</span>
              <span data-id="element-163">17/25 cupos ocupados</span>
            </div>
            <div className="w-full h-2 bg-cream/10 rounded-full overflow-hidden" data-id="element-164">
              <div className="h-full bg-gold rounded-full w-[68%] relative" data-id="element-165">
                <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-166"></div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Decorative bottom wave or fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-cream to-transparent z-10" data-id="element-167"></div>
    </section>;
}